import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsVacationManager } from '../../hooks/useIsVacationManager';
import { LoadingSpinner } from '@/components/LoadingSpinner';

interface VacationApprovalGuardProps {
    children: React.ReactNode;
    redirectTo?: string;
}

export function VacationApprovalGuard({ children, redirectTo = '/collaborators/directory' }: VacationApprovalGuardProps) {
    const { isManager, isLoading } = useIsVacationManager();

    if (isLoading) {
        return <LoadingSpinner />;
    }

    if (!isManager) {
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
}
